import { render, staticRenderFns } from "./SendPopUp.vue?vue&type=template&id=10eeaeaa&scoped=true"
import script from "./SendPopUp.vue?vue&type=script&lang=js"
export * from "./SendPopUp.vue?vue&type=script&lang=js"
import style0 from "./SendPopUp.vue?vue&type=style&index=0&id=10eeaeaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10eeaeaa",
  null
  
)

export default component.exports